import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FaDiscord, FaExternalLinkAlt, FaInstagram, FaMedium, FaTwitter } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Container from '../../components/Container'
import useScrollTrigger from '../../hooks/useScrollTrigger'
import logo from '../media/logo-black.png'
import { StyledDisabledLink, StyledNavLink, StyledOutsideLink } from '../theme/Texts'
import HamburgerMenu from './HamburgerMenu'
// import {MINTING_START_TIMESTAMP} from "../../constants/envVars";
// import Countdown from "react-countdown";

const navItems = [
	{
		name: 'HOME',
		link: '/',
		isMenu: false,
		outsideLink: false,
		newTab: false,
		disabled: false,
	},
	{
		name: 'REVAMP',
		link: '/revamp',
		isMenu: false,
		outsideLink: false,
		newTab: false,
		disabled: false,
	},
	// {
	// 	name: 'EVE',
	// 	link: '/the-sevens-eve',
	// 	isMenu: false,
	// 	outsideLink: false,
	// 	newTab: false,
	// 	disabled: false,
	// },
	{
		name: 'THE CLUSTER',
		link: '/the-cluster',
		isMenu: false,
		outsideLink: false,
		newTab: false,
		disabled: false,
	},
	{
		name: 'THE SURVIVORS',
		link: '/the-survivors',
		isMenu: false,
		outsideLink: false,
		newTab: false,
		disabled: false,
	},
	{
		name: 'OUR PATH',
		link: '/our-path',
		isMenu: false,
		outsideLink: false,
		newTab: false,
		disabled: true,
	},
	{
		name: 'MANIFESTO',
		link: '/manifesto',
		isMenu: false,
		outsideLink: false,
		newTab: false,
		disabled: false,
	},
	{
		name: 'MEMBERS',
		link: 'https://members.thesevensofficial.com',
		isMenu: false,
		outsideLink: true,
		newTab: false,
		disabled: false,
	},
	// {
	// 	name: 'Staking (Old)',
	// 	link: '/dojo',
	// 	isMenu: false,
	// 	outsideLink: false,
	// 	newTab: false,
	// 	disabled: false,
	// }
]

const socials = [
	{
		icon: FaDiscord,
		url: 'https://discord.gg/the-sevens-gbtw',
		title: 'Discord',
	},
	{
		icon: FaTwitter,
		url: 'https://twitter.com/thesevens_7',
		title: 'Twitter',
	},
	{
		icon: FaInstagram,
		url: 'https://www.instagram.com/thesevensofficial_777/',
		title: 'Instagram',
	},
	{
		icon: FaMedium,
		url: 'https://medium.com/@TheSevensOfficial',
		title: 'Medium',
	},
	{
		icon: (props) => (
			<svg width="1em" height="1em" {...props} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M6 0C2.6868 0 0 2.6868 0 6C0 9.3132 2.6868 12 6 12C9.3132 12 12 9.3132 12 6C12 2.6868 9.3144 0 6 0ZM2.9604 6.2016L2.9856 6.1608L4.5468 3.7188C4.5696 3.684 4.6236 3.6876 4.6404 3.726C4.9008 4.3104 5.1264 5.0376 5.0208 5.49C4.9764 5.676 4.8528 5.928 4.7136 6.1608C4.6956 6.1944 4.6764 6.228 4.6548 6.2604C4.6452 6.2748 4.6284 6.2832 4.6104 6.2832H3.006C2.9628 6.2832 2.9376 6.2364 2.9604 6.2016ZM9.9168 7.0416C9.9168 7.0644 9.9036 7.0836 9.8844 7.092C9.7632 7.1436 9.3492 7.3344 9.1776 7.5732C8.7384 8.184 8.4036 9.0576 7.6536 9.0576H4.5264C3.4176 9.0576 2.52 8.1564 2.52 7.044V7.008C2.52 6.9792 2.544 6.9552 2.574 6.9552H4.3164C4.3512 6.9552 4.3764 6.9864 4.374 7.0212C4.3608 7.134 4.3824 7.2504 4.4364 7.356C4.5396 7.566 4.7544 7.6968 4.986 7.6968H5.8488V7.0236H4.9956C4.9524 7.0236 4.926 6.9732 4.9512 6.9372C4.9608 6.9228 4.9704 6.9084 4.9824 6.8916C5.0628 6.7764 5.178 6.5988 5.2932 6.396C5.3712 6.2592 5.4468 6.1128 5.508 5.9664C5.52 5.94 5.5296 5.9124 5.5404 5.886C5.5572 5.8392 5.574 5.7948 5.586 5.7516C5.598 5.7144 5.6088 5.676 5.6184 5.64C5.6472 5.5152 5.6592 5.3832 5.6592 5.2464C5.6592 5.1924 5.6568 5.136 5.652 5.0832C5.6496 5.0244 5.6424 4.9656 5.6352 4.9068C5.6304 4.8552 5.6208 4.8036 5.6112 4.7508C5.598 4.6728 5.5812 4.5948 5.562 4.5168L5.5548 4.4868C5.5404 4.4328 5.5272 4.3824 5.5104 4.3284C5.4612 4.1604 5.406 3.996 5.346 3.8424C5.3244 3.7812 5.3004 3.7224 5.2752 3.6648C5.2392 3.576 5.202 3.4956 5.1684 3.42C5.1504 3.3852 5.136 3.354 5.1216 3.3216C5.1048 3.2856 5.088 3.2496 5.07 3.2148C5.058 3.1884 5.0436 3.1632 5.034 3.1392L4.9284 2.9448C4.914 2.9184 4.938 2.886 4.9668 2.8944L5.6268 3.0732H5.6292C5.6304 3.0732 5.6304 3.0732 5.6316 3.0732L5.718 3.0984L5.814 3.1248L5.8488 3.1344V2.7432C5.8488 2.5536 6 2.4 6.1884 2.4C6.282 2.4 6.3672 2.4384 6.4272 2.5008C6.4884 2.5632 6.5268 2.6484 6.5268 2.7432V3.3252L6.5976 3.3444C6.6024 3.3468 6.6084 3.3492 6.6132 3.3528C6.63 3.3648 6.6552 3.384 6.6864 3.408C6.7116 3.4272 6.738 3.4512 6.7692 3.4764C6.8328 3.528 6.9096 3.594 6.9924 3.6696C7.014 3.6888 7.0356 3.708 7.056 3.7284C7.1628 3.828 7.2828 3.9444 7.398 4.074C7.4304 4.1112 7.4616 4.1472 7.494 4.1868C7.5252 4.2264 7.56 4.2648 7.5888 4.3032C7.6284 4.3548 7.6692 4.4088 7.7064 4.4652C7.7232 4.4916 7.7436 4.5192 7.7592 4.5456C7.8072 4.6164 7.848 4.6896 7.8876 4.7628C7.9044 4.7964 7.9212 4.8336 7.9356 4.8696C7.98 4.968 8.0148 5.0676 8.0364 5.1684C8.0436 5.19 8.0484 5.2128 8.0508 5.2344V5.2392C8.058 5.268 8.0604 5.2992 8.0628 5.3316C8.0724 5.4336 8.0676 5.5368 8.046 5.64C8.0364 5.6832 8.0244 5.724 8.01 5.7684C7.9944 5.8104 7.98 5.8536 7.9608 5.8956C7.9236 5.9808 7.8804 6.0672 7.8288 6.1464C7.812 6.1764 7.7916 6.2076 7.7724 6.2376C7.7508 6.2688 7.728 6.2988 7.7088 6.3276C7.6812 6.3648 7.6524 6.4032 7.6224 6.438C7.596 6.474 7.5696 6.51 7.5396 6.5424C7.4988 6.5916 7.4592 6.6372 7.4172 6.6816C7.3932 6.7104 7.3668 6.7404 7.3392 6.7668C7.3128 6.7968 7.2852 6.8232 7.2612 6.8472C7.2192 6.8892 7.1856 6.9204 7.1568 6.948L7.0884 7.0092C7.0788 7.0188 7.0656 7.0236 7.0524 7.0236H6.5268V7.6968H7.188C7.3356 7.6968 7.476 7.6452 7.59 7.548C7.6284 7.5144 7.7976 7.368 7.998 7.1472C8.0052 7.1388 8.0136 7.134 8.0232 7.1316L9.8484 6.6036C9.8832 6.594 9.9168 6.6192 9.9168 6.6552V7.0416Z"
					fill="currentColor"
				/>
			</svg>
		),

		url: 'https://opensea.io/collection/the-sevens-genesis',
		title: 'Open Sea',
	},
]

// @ts-ignore
// const countdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
// 	if (completed) {
// 		// Render a completed state
//     return <span>The Sevens Companion Mint is now live, click here to mint!</span>;
// 	} else {
// 		// Render a countdown
// 		return (
// 			<span>
// 				The Sevens Companion Mint is starting in {days > 0 ? `${days}d ` : ''}
// 				{hours}h {minutes}m {seconds}s!
// 			</span>
// 		);
// 	}
// };

export default function Nav() {
	const isScrolled = useScrollTrigger({
		disableHysteresis: true,
	})

	return (
		<>
			<NavContainer className={isScrolled ? 'scrolled' : ''}>
				{/*<NotificationBar>*/}
				{/*	<Container>*/}
				{/*		<NotificationBarLink to="/mint">*/}
				{/*			<Countdown date={MINTING_START_TIMESTAMP} renderer={countdownRenderer} />*/}
				{/*		</NotificationBarLink>*/}
				{/*	</Container>*/}
				{/*</NotificationBar>*/}
				<Container>
					<NavInner>
						<Link to="/">
							<LogoContainer style={{ backgroundImage: `url(${logo})` }} />
						</Link>

						<HamburgerMenu items={navItems} socials={socials} />

						<NavWrapper>
							{navItems.map((nav) => {
								if (nav.outsideLink) {
									return (
										<StyledOutsideLink
											href={nav.link}
											{...(nav.newTab ? { target: '_blank' } : {})}
											rel="noreferrer"
											key={nav.name}
											className="inline-flex items-center"
										>
											{nav.name}
											{nav.newTab && <FaExternalLinkAlt width={12} height={12} className="ml-2" />}
										</StyledOutsideLink>
									)
								}
								if (nav.disabled) {
									return (
										<OverlayTrigger
											key={nav.name}
											placement="bottom"
											overlay={<Tooltip id={nav.name}>Wen? Soon ™</Tooltip>}
										>
											<StyledDisabledLink className={nav.disabled ? 'disabled' : ''}>{nav.name}</StyledDisabledLink>
										</OverlayTrigger>
									)
								}

								return (
									<StyledNavLink exact to={nav.link} key={nav.name}>
										{nav.name}
									</StyledNavLink>
								)
							})}
						</NavWrapper>

						<SocialMenu>
							{socials.map(({ title, icon: Icon, url }) => (
								<a className="text-white" href={url} title={title} key={title}>
									<Icon />
								</a>
							))}
						</SocialMenu>
					</NavInner>
				</Container>
			</NavContainer>
		</>
	)
}

const NavContainer = styled.div`
	position: sticky;
	top: 0;
	width: 100%;
	z-index: 1000;
	transition: 0.2s ease;
	backdrop-filter: blur(0);
	background: rgba(0, 0, 0, 0);

	&.scrolled {
		backdrop-filter: blur(10px);
		background: rgba(0, 0, 0, 0.4);
	}
`

const NavInner = styled.div`
	display: grid;
	align-items: center;
	grid-template-columns: 1fr auto 1fr;
	padding: 24px;
	width: 100%;

	@media (max-width: 992px) {
		grid-template-columns: auto auto;
	}
`

const LogoContainer = styled.div`
	width: 64px;
	height: 55px;
	z-index: 1;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
`

const NavWrapper = styled.div`
	display: flex;
	z-index: 1;
	gap: 16px;

	@media (max-width: 992px) {
		display: none;
	}
`

const SocialMenu = styled.nav`
	display: flex;
	justify-content: flex-end;
	gap: 12px;

	@media (max-width: 992px) {
		display: none;
	}
`
